"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON = exports.ARR_COLUMN_SPAN = void 0;
var ICON = {
  SLIDER_BUTTON_LEFT: 'ChevronLeftIcon',
  SLIDER_BUTTON_RIGHT: 'ChevronRightIcon'
};
exports.ICON = ICON;
var ARR_COLUMN_SPAN = ['2', '3', '4', '1'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;